import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.to-string.js";
var SCROLLABLE_OVERFLOW = ['auto', 'scroll'];

/**
 * Checks whether a passed-in style prop results in a scrollable
 * style (`overflow: auto` or `overflow: scroll`) for the element
 * it's attached to.
 */

function isOverflowScrollable(overflowProp, theme) {
  if (!overflowProp) {
    return false;
  }
  if (Array.isArray(overflowProp)) {
    return overflowProp.some(function (value) {
      return isOverflowScrollable(value, theme);
    });
  } else if (typeof overflowProp === 'function') {
    return isOverflowScrollable(overflowProp(theme), theme);
  } else {
    return SCROLLABLE_OVERFLOW.includes(overflowProp);
  }
}
export default isOverflowScrollable;